import * as React from 'react';

/** Material UI Packages. */
import { Box, Grid, Typography, Divider } from '@mui/material';

/** Internal Components. */
import FormField from '../../components/FormField';

export default function AccountInfo(props) {
    /** Get props from AccountSetting.js. */
    const { acctRows, selectedId } = props;

    const selectedAccount = acctRows.find((item) => item.id === selectedId);

    return (
        <Box sx={{ my: 2, mx: 5, maxWidth: '50%' }}>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                width: '3px',
                                height: '16px',
                                backgroundColor: 'primary.main',
                            }}
                        />
                        <Typography sx={{ fontWeight: 500, fontSize: 16, color: 'text.secondary' }}>
                            Account Info
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={6}>
                    <FormField label="First Name" value={selectedAccount?.first_name || ''} readOnly={true} />
                </Grid>
                <Grid size={6}>
                    <FormField label="Last Name" value={selectedAccount?.last_name || ''} readOnly={true} />
                </Grid>
                <Grid size={6}>
                    <FormField
                        label="Account Email"
                        value={selectedAccount?.email || ''}
                        type="email"
                        readOnly={true}
                    />
                </Grid>
                <Grid size={6}>
                    <FormField
                        label="Email Verified"
                        value={selectedAccount?.email_verified ? 'Yes' : 'No'}
                        readOnly={true}
                        textFieldStyle={{
                            '& .MuiInputBase-input': {
                                color: selectedAccount?.email_verified ? 'green' : 'red',
                                cursor: 'default',
                                border: '1px solid',
                                borderColor: selectedAccount?.email_verified ? 'green' : 'red',
                                borderRadius: '5px',
                                textAlign: 'center',
                            },
                        }}
                    />
                </Grid>
                <Grid size={6}>
                    <FormField label="Company Name" value={selectedAccount?.company_name || ''} readOnly={true} />
                </Grid>
                <Grid size={6}>
                    <FormField label="Position" value={selectedAccount?.company_position || ''} readOnly={true} />
                </Grid>
                <Grid size={12}>
                    <Divider sx={{ my: 1 }} />
                </Grid>
                <Grid size={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                width: '3px',
                                height: '16px',
                                backgroundColor: 'primary.main',
                            }}
                        />
                        <Typography sx={{ fontWeight: 500, fontSize: 16, color: 'text.secondary' }}>Login</Typography>
                    </Box>
                </Grid>
                <Grid size={4}>
                    <FormField
                        label="Created At"
                        readOnly={true}
                        value={
                            selectedAccount?.create_at
                                ? new Date(selectedAccount.create_at).toLocaleDateString('en-US', {
                                      month: '2-digit',
                                      day: '2-digit',
                                      year: 'numeric',
                                  })
                                : ''
                        }
                    />
                </Grid>
                <Grid size={4}>
                    <FormField
                        label="Last Login"
                        readOnly={true}
                        value={
                            selectedAccount?.last_login
                                ? (() => {
                                      const date = new Date(selectedAccount.last_login);
                                      const dateStr = date.toLocaleDateString('en-US', {
                                          month: '2-digit',
                                          day: '2-digit',
                                          year: 'numeric',
                                      });
                                      const timeStr = date.toLocaleTimeString('en-US', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: false,
                                      });
                                      return `${dateStr} @${timeStr}`;
                                  })()
                                : ''
                        }
                    />
                </Grid>
                <Grid size={4}>
                    <FormField label="Logins Count" value={selectedAccount?.logins_count || ''} readOnly={true} />
                </Grid>
                <Grid size={12}>
                    <Divider sx={{ my: 1 }} />
                </Grid>
                <Grid size={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                width: '3px',
                                height: '16px',
                                backgroundColor: 'primary.main',
                            }}
                        />
                        <Typography sx={{ fontWeight: 500, fontSize: 16, color: 'text.secondary' }}>
                            Service Setting
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={4}>
                    <FormField label="Current Service" value={selectedAccount?.service_name || ''} readOnly={true} />
                </Grid>
            </Grid>
        </Box>
    );
}
